"use client";

import { type Application } from "@/types";

export const FileManager: Application["Component"] = () => null;
